import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as styles from '~src/styles/domains/reapply/ReapplyPage.module.scss';
import { trackPageMount } from '~src/utils/tracking';
import { Page } from '../common/enums/api';
import { setShowBanner } from '../common/state/commonReducer';
import { brandSelector } from '../common/state/commonSelectors';

const ReapplyPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const brand = useSelector(brandSelector);

  useEffect(() => {
    dispatch(trackPageMount(Page.REAPPLY));
    dispatch(setShowBanner(false));
  }, []);

  return (
    <div className={styles['reapply-wrapper']}>
      <h2 className={`header-txt ${styles['reapply-header']}`}>
        {t('reapply:header')}
      </h2>
      <div className={styles['reapply-body']}>
        <p>{t(`reapply:${brand.toLowerCase()}.subheader`)}</p>
        <p>{t('reapply:didNotRequest')}</p>
      </div>
    </div>
  );
};

export default ReapplyPage;
